import React from "react"
import ReactApexChart from "react-apexcharts"

// const barchart = () => {
//   const series = [
//     {
//       data: [380, 430, 450, 475, 550, 584, 780, 1100, 1220, 1365],
//     },
//   ]
//   const options = {
//     chart: {
//       toolbar: {
//         show: false,
//       },
//     },
//     plotOptions: {
//       bar: {
//         horizontal: false,
//       },
//     },
//     dataLabels: {
//       enabled: false,
//     },

//     colors: ["#8E7CC3"],
//     grid: {
//       borderColor: "#8699ad",
//     },
//     xaxis: {
//       categories: [
//         "South Korea",
//         "Canada",
//         "United Kingdom",
//         "Netherlands",
//         "Italy",
//         "France",
//         "Japan",
//         "United States",
//         "China",
//         "Germany",
//       ],
//     },
//   }

//   return (
//     <ReactApexChart options={options} series={series} type="bar" height="350" />
//   )
// }
const barchart = ({data}) => {
  
  // const data = {
  //   country: "India",
  //   totalInstitutions: 700,
  //   categories: {
  //     Engineering: 358,
  //     Management: 241,
  //     Pharmacy: 37,
  //     Law: 31,
  //     Architecture: 16,
  //     "Engineering & Technology": 8,
  //     Agriculture: 5,
  //     "Engineering & Technology, Science": 1,
  //     "Engineering/Pharmacy": 1,
  //     "Pharmacy/Allied Health": 1,
  //     "Engineering &Technology": 1,
  //   },
  // };

  const series = [
    {
      name: "Categories",
      data: Object.values(data.categories),
    },
  ];

  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    dataLabels: {
      enabled: true,
    },
    colors: ["#8E7CC3"],
    grid: {
      borderColor: "#8699ad",
    },
    xaxis: {
      categories: Object.keys(data.categories),
    },
    title: {
      text: `Total Institutions: ${data.totalInstitutions}`,
      align: "center",
    },
  };

  return (
    <div>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height="500"
      />
    </div>
  );
};

export default barchart
